import React from 'react';
import { motion } from 'framer-motion';
export function EliteSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-oscuro mb-4" data-id="element-66">
            ¿Qué agrega el Megapack Élite?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-600" data-id="element-67">
            Por solo $9.000 más, llevas tu enseñanza al siguiente nivel.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-hueso p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-69">
            <div className="text-4xl mb-4" data-id="element-70">🛡️</div>
            <h3 className="text-2xl font-bold text-oscuro mb-4" data-id="element-71">
              Élite 1 — Manual de Modificaciones
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-72">
              100 variantes para alumnos con hernias, lesiones, embarazo o
              sobrepeso. No sigas improvisando con la salud de tus alumnos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-hueso p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-73">
            <div className="text-4xl mb-4" data-id="element-74">🔋</div>
            <h3 className="text-2xl font-bold text-oscuro mb-4" data-id="element-75">
              Élite 2 — Energía Blindada
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-76">
              Tu guía de autocuidado real. Técnicas de protección energética
              para no terminar el día 'quemado' ni absorber el estrés de tus
              alumnos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}